"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDrawerHeight = void 0;
var _react = require("react");
var _constants = require("../constants");
const useDrawerHeight = elementRef => {
  const [height, setHeight] = (0, _react.useState)();
  const [sizeInitialized, setSizeInitialized] = (0, _react.useState)(false);
  const [touchEnded, setTouchEnded] = (0, _react.useState)(false);
  const [maxHeight, setMaxHeight] = (0, _react.useState)(0);
  const [minHeight, setMinHeight] = (0, _react.useState)(0);
  const [mapIsFocused, setMapIsFocused] = (0, _react.useState)(true);
  const focusOnList = (0, _react.useCallback)(() => {
    setHeight(maxHeight);
    setMapIsFocused(false);
  }, [maxHeight]);
  const focusOnMap = (0, _react.useCallback)(() => {
    setHeight(minHeight);
    setMapIsFocused(true);
  }, [minHeight]);

  // Calculate min and max height based on the viewport
  (0, _react.useEffect)(() => {
    const onResize = () => {
      setMaxHeight(window.innerHeight * _constants.DRAWER_MAX_HEIGHT_PERCENTAGE * 0.01);
      setMinHeight(window.innerHeight * _constants.DRAWER_MIN_HEIGHT_PERCENTAGE * 0.01);
    };
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Initialize height based on the element's dimensions
  (0, _react.useEffect)(() => {
    if (elementRef.current && !sizeInitialized) {
      setHeight(elementRef.current.offsetHeight);
      setSizeInitialized(true);
    }
  }, [elementRef, sizeInitialized]);

  // Set the height to the min or max height based on the touch end position
  (0, _react.useEffect)(() => {
    if (touchEnded) {
      const halfPoint = (minHeight + maxHeight) / 2;
      if (height != null && height >= halfPoint) {
        focusOnList();
      } else {
        focusOnMap();
      }
      setTouchEnded(false);
    }
  }, [focusOnList, focusOnMap, height, maxHeight, minHeight, touchEnded]);

  // Handle resizing of the drawer during touch and drag
  const onTouchStart = (0, _react.useCallback)(touchStartEvent => {
    touchStartEvent.preventDefault();
    setMapIsFocused(true);
    const startHeight = height;
    const startPosition = {
      x: touchStartEvent.touches[0]?.pageX ?? 0,
      y: touchStartEvent.touches[0]?.pageY ?? 0
    };
    const onTouchMove = mouseMoveEvent => {
      setHeight((startHeight ?? 0) + startPosition.y - (mouseMoveEvent.touches[0]?.pageY ?? 0));
    };
    const onTouchEnd = () => {
      document.body.removeEventListener('touchmove', onTouchMove);
      setTouchEnded(true);
    };
    document.body.addEventListener('touchmove', onTouchMove);
    document.body.addEventListener('touchend', onTouchEnd, {
      once: true
    });
  }, [height]);
  return (0, _react.useMemo)(() => ({
    height,
    mapIsFocused,
    focusOnList,
    focusOnMap,
    onTouchStart
  }), [height, mapIsFocused, focusOnList, focusOnMap, onTouchStart]);
};
exports.useDrawerHeight = useDrawerHeight;